<app-nav />
<main class="landing-main">
    <app-hero />
    <section class="bbva-banner">
        <img src="./assets/bbva-seguros-logo-negativo.png" alt="BBVA Seguros" class="bbva-banner__logo">
    </section>
    <app-sponsors />
    <app-characteristics />
    <app-digitize />
    <app-how />
    <app-questions />
    <!-- <app-table /> -->
    <app-contact />
    <a [href]="'https://wa.me/5493413439207?text=Quiero saber más sobre AdminAI'" target="_blank" class="suport-button">
        <img src="./assets/whatsapp-logo.svg" alt="">
    </a>

</main>

<app-footer />
